import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })
  let personMatch = useDataValue({
    viewPath: props.viewPath,
    context: 'person_match',
  })

  return function onClick(value) {
    if (value) {
      change(next => {
        next.id = personMatch.id
        next.type = personMatch.type
      })
    } else {
      change(null)
    }
  }
}
